import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import AutocompleteField from './AutocompleteField';

RAutocompleteField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  control: PropTypes.any,
  status: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
      path: PropTypes.string,
    })
  ),
};

export function RAutocompleteField({
  status,
  label,
  name,
  control,
  options,
  ...rest
}) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <AutocompleteField
          name={name}
          label={label}
          value={value}
          options={options}
          status={status}
          onChange={onChange}
          error={!!error}
          helperText={error?.message ?? ''}
          {...rest}
        />
      )}
    />
  );
}
